// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + {"4297": "aura-forms","5176": "framer-motion",}[chunkId] + "." + {"4297": "87620603da6bbe5a","5176": "45544d7dde5b051c",}[chunkId] + ".js"
}